// src/components/ui/layout/NeomorphicFrameStyles.tsx
"use client";

import "./NeomorphicFrameStyles.css";

export function NeomorphicFrameStyles() {
  return null;
}
